module.exports = __webpack_public_path__ + "img/wandh-guideline-disabled.e7b14dd.svg";